"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var VariableSignature = /\(?[\w\-.[\]]\)?/;
var SYNTAX = new RegExp("((?:" + VariableSignature.source + ")+)\\s*=\\s*(.*)\\s*", 'i');
var SYNTAX_HELP = "Syntax Error in 'assign' - Valid syntax: assign [var] = [value]";

/**
 * Creates a new variable.
 * Also handles array notation in addition to the builtin liquid behavior:
 *   https://liquidjs.com/tags/assign.html
 */
var _default = exports["default"] = {
  /**
   * Parses the assignment expression.
   */
  parse: function parse(tagToken, _remainTokens) {
    var expression = tagToken.args;
    var match = SYNTAX.exec(expression);
    if (!match) {
      throw new Error(SYNTAX_HELP);
    }
    this.variable = match[1];
    var arrayValue = parseArrayValue(match[2]);
    this.value = Array.isArray(arrayValue) ? arrayValue : match[2];
  },
  /**
   * Assigns the value.
   */
  render: function () {
    var _render = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(context) {
      var _this = this;
      var from;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!Array.isArray(this.value)) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return Promise.all(this.value.map(function (v) {
              return _this.liquid.evalValue(v, context);
            }));
          case 3:
            from = _context.sent;
            _context.next = 9;
            break;
          case 6:
            _context.next = 8;
            return this.liquid.evalValue(this.value, context);
          case 8:
            from = _context.sent;
          case 9:
            context.bottom()[this.variable] = from;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function render(_x) {
      return _render.apply(this, arguments);
    }
    return render;
  }()
};
function parseArrayValue(source) {
  var arrMatch = /^\[(.*)\]$/.exec(source.trim());
  if (arrMatch) {
    if (arrMatch[1].trim() === '') {
      return [];
    }
    return arrMatch[1].split(/\s*,\s*/);
  }
  return undefined;
}